import { Navigate, Outlet } from "react-router-dom";
import Header from './header/Header';
import Footer from "./footer/Footer";
import Sidebar from "./sidebar/Sidebar";

const RequireAuth = () => {
    const accessToken = sessionStorage.getItem('accesstoken');

    const renderLayout = () => (
        <div className="rty">
            <Header />
            <div className="body">
                <main>
                    <Outlet />
                </main>
                <Sidebar />
            </div>
            <Footer />
        </div>
    );

    return !accessToken ? <Navigate to='/error' /> : renderLayout();
}

export default RequireAuth;
